// @flow
import React, { type Node } from 'react'
import { Notification } from 'sarsaparilla'
import { uniqueId } from 'lodash';

import { parseFormattedErrorMessageString, parseErrorMessageIntoStringList } from '../utils/handleBackEndError';

export type ErrorNotificationProps = {
    isShow: boolean,
    dismiss?: Function,
    body?: string,
    title?: string,
    className?: string,
}
export default function ErrorNotification({
    isShow = false,
    dismiss,
    body,
    title = "You've encountered the following error(s):",
    className,
}: ErrorNotificationProps) {
    return !!isShow && (
        <Notification
            type="error"
            dismissNotification={dismiss}
            shouldFocusOnMount
            title={title}
            className={className}>
            <ErrorNotification.Body>
                {parseErrorMessageIntoStringList(parseFormattedErrorMessageString(body))}
            </ErrorNotification.Body>
        </Notification>
    )
}

ErrorNotification.Body = ({children}: {children?: Node}) => {
    if(Array.isArray(children)) {
        return (
            <ul>
                {children?.map((e) => (
                    <li key={uniqueId()}>{e}</li>
                ))}
            </ul>
        )
    }
    return <> {children} </>
}